// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1OX56","rootCenter":"LoadMoreObserver_rootCenter__Aa-Nn","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1-_iL"};